import { createFileRoute } from '@tanstack/react-router'
import { ModuleGate } from '@/components/module-gate'

export const Route = createFileRoute('/_authed/products')({
  component: () => (
    <ModuleGate moduleKey="products">
      <Products />
    </ModuleGate>
  ),
})

function Products() {
  return (
    <div className="p-8">
      <h2 className="text-2xl font-bold">Products</h2>
      <p className="mt-2 text-muted-foreground">Coming in Phase 1e.</p>
    </div>
  )
}
